
export enum EventType {
    CREATED_NEW_USER = 'created-new-user',
    ACCOUNT_UPDATE = 'account-update',
    PASSWORD_RESET = 'password-reset'
}
